export const PROMOTION_REBATE_FIELD_NAME = 'activePromotionsId'
export const PROMOTION_TIRE_FIELD_NAME = 'avaliblePromotionsId'
export const PROMOTION_LIGHT_BOX_FORM = 'promotionLightBox'
